export enum CommandeStatus {
  INITIER = "INITIER",
  EN_EDITION = "EN_EDITION",
  EN_COUR_FABRICATION = "EN_COUR_FABRICATION",
  FABRIQUE = "FABRIQUE",
  EN_COURS_LIVRAISON = "EN_COURS_LIVRAISON",
  LIVRE = "LIVRE",
  INTERROMPUE = "INTERROMPUE",
  ANNULE = "ANNULE",
  REFUSER = "REFUSER",
}

export enum CommandeStatusColor {
  INITIER = "gray",
  EN_EDITION = "purple",
  EN_COUR_FABRICATION = "blue",
  FABRIQUE = "white",
  EN_COURS_LIVRAISON = "yallow",
  LIVRE = "green",
  INTERROMPUE = "orange",
  ANNULE = "brown",
  REFUSER = "red",
}

export const CommandeStatusOptions = [
  { value: " ", label: "Choisissez un statut" },
  { value: CommandeStatus.INITIER, label: CommandeStatus.INITIER },
  { value: CommandeStatus.EN_EDITION, label: CommandeStatus.EN_EDITION },
  {
    value: CommandeStatus.EN_COUR_FABRICATION,
    label: CommandeStatus.EN_COUR_FABRICATION,
  },
  { value: CommandeStatus.FABRIQUE, label: CommandeStatus.FABRIQUE },
  {
    value: CommandeStatus.EN_COURS_LIVRAISON,
    label: CommandeStatus.EN_COURS_LIVRAISON,
  },
  { value: CommandeStatus.LIVRE, label: CommandeStatus.LIVRE },
  { value: CommandeStatus.INTERROMPUE, label: CommandeStatus.INTERROMPUE },
  { value: CommandeStatus.ANNULE, label: CommandeStatus.ANNULE },
  { value: CommandeStatus.REFUSER, label: CommandeStatus.REFUSER },
];
